module.exports = __webpack_public_path__ + "static/media/md-information-circle-outline.d2e3e7f9.svg";